var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 2.8125H7.1875C6.02718 2.8125 4.91438 3.27344 4.09391 4.09391C3.27344 4.91438 2.8125 6.02718 2.8125 7.1875V32.8125C2.8125 33.9728 3.27344 35.0856 4.09391 35.9061C4.91438 36.7266 6.02718 37.1875 7.1875 37.1875H19.7398V22.8847H16.8793V17.1636H19.7162V14.5781C19.7162 12.2381 20.8309 8.58234 25.7364 8.58234L30.1555 8.60008V13.5017H26.9463C26.4245 13.5017 25.682 13.7616 25.682 14.8761V17.164H30.2285L29.7066 22.8851H25.4609V37.1875H32.8125C33.9728 37.1875 35.0856 36.7266 35.9061 35.9061C36.7266 35.0856 37.1875 33.9728 37.1875 32.8125V7.1875C37.1875 6.02718 36.7266 4.91438 35.9061 4.09391C35.0856 3.27344 33.9728 2.8125 32.8125 2.8125Z",
    fill: "#342153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/facebook 1.23b1f9f017a746316b0cbfc7f32f2aa8.svg";
export { ForwardRef as ReactComponent };